module.exports = __webpack_public_path__ + "img/twitter_aki_suzuya.b1c42bbf.jpeg";